import { createVideoAdapter } from '../../shared/video/adapter/adapter';

export const ProjectVideoKey = 'projectVideo';

export const projectVideoAdapter = createVideoAdapter({
  stateKeyOrSelector: ProjectVideoKey,
  type: 'Project Video',
});
